// ============================================================================
// PairsForm - Bannière de visite d'organisation (SUPER_ADMIN)
// ============================================================================
// Affichée en haut de l'écran quand le SUPER_ADMIN visite une autre org

import { Box, Button, Typography } from "@mui/material";
import { Building2, ArrowLeft } from "lucide-react";
import { useOrganisation } from "../contexts/OrganisationContext";

export function OrgVisitBanner() {
  const { impersonating, selectedOrganisationOverride, setSelectedOrganisationOverride } = useOrganisation();

  // Affichée pendant toute l'immersion. On NE peut PAS gater sur le rôle
  // SUPER_ADMIN : en immersion le token est réduit à PILOTE — sinon le bouton de
  // sortie disparaîtrait et on resterait coincé dans l'org visitée.
  if (!impersonating || !selectedOrganisationOverride) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, md: 3 },
        py: 1,
        bgcolor: "#E1512C",
        color: "white",
        gap: 2,
        minHeight: 44,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        <Building2 size={20} />
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          Vous visitez : {selectedOrganisationOverride.nom}
        </Typography>
      </Box>

      <Button
        variant="outlined"
        size="small"
        startIcon={<ArrowLeft size={16} />}
        onClick={() => setSelectedOrganisationOverride(null)}
        sx={{
          color: "white",
          borderColor: "rgba(255,255,255,0.5)",
          whiteSpace: "nowrap",
          flexShrink: 0,
          "&:hover": {
            borderColor: "white",
            bgcolor: "rgba(255,255,255,0.1)",
          },
        }}
      >
        Retour à CECODEV
      </Button>
    </Box>
  );
}
